import SummaryOfCounterfeitGoods from './summary_of_counterfeit_goods.vue';

export default SummaryOfCounterfeitGoods;
